import { createSlice } from '@reduxjs/toolkit';

import { messageAdded } from '../../actions/cruiseListActions';

// **Replaces rather than merges**, and the guard means a falsy message leaves the previous one in
// place. `init` can dispatch this twice — once for a non-200 and once for the API's translated
// message — so the second call wins. Preserved.
const messageSlice = createSlice({
  name: 'message',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(messageAdded, (state, action) => action.payload || state);
  },
});

export default messageSlice.reducer;
